import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TypedAction } from '@ngrx/store/src/models';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import { LeadModel } from '../../models/Lead.model';
import {
  IMessagesService,
  MESSAGES_SERVICE,
} from '../../services/IMessages.service';
import * as fromLeadsActions from '../actions/leads.actions';
import * as fromActions from '../messages.actions';
import { LeadsStore } from '../store/leads.store';

@Injectable()
export class LeadsEffects {
  getLeads$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromLeadsActions.getLeadsBeginAction),
      switchMap(() =>
        this.service.getLeads().pipe(
          mergeMap((response) => {
            const payload = response.leads;
            return of([
              fromActions.clearConversationSuccessErrorDataAction(),
              fromLeadsActions.getLeadsSuccessAction({ payload }),
            ]).pipe(switchMap((d) => d));
          }),
          catchError((error) => {
            console.error('Could not get Leads', error);
            return of([
              fromLeadsActions.getLeadsFailAction({ errors: error }),
              fromActions.clearConversationSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  setLeadAsRead$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromLeadsActions.setLeadAsReadBeginAction),
      withLatestFrom(this.leadsStore.data$),
      switchMap(([action, prevState]) =>
        this.service.setLeadAsRead(action.leadId).pipe(
          mergeMap((updatedLead) => {
            const payload = [...prevState];
            const idx = payload.findIndex((el) => el.id === action.leadId);
            payload.splice(idx, 1, updatedLead);

            return of([
              fromLeadsActions.setLeadAsReadSuccessAction({ payload }),
              fromActions.clearConversationSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          }),
          catchError((error) => {
            console.error('Could not set message as read', error);
            return of([
              fromLeadsActions.setLeadAsReadFailAction({ errors: error }),
              fromActions.clearConversationSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    @Inject(MESSAGES_SERVICE) private service: IMessagesService,
    private leadsStore: LeadsStore
  ) {}
}
